import styled from '@emotion/styled'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { lighten } from 'polished'

import { Card, Flex } from '../../../App/Components'
import { IAbsenceRequestStatus } from '../../../HR/AbsenceRequests/Client/IAbsenceRequest'

const defaultIconColor: string = '#000'

const statusColor = (status: IAbsenceRequestStatus) => {
  switch (status) {
    case 'PENDING':
      return '#fbb03b'
    case 'APPROVED':
      return '#69d321'
    case 'DECLINED':
      return '#d24444'
    case 'CANCELED':
      return '#d24444'
  }
}

export const CardContainer = styled(Card)`
  height: fit-content;
  padding: 5px;
  background-color: #0ec1f7;
`

export const TopHalf = styled(Flex)`
  margin-bottom: 2em;
`

export const TitleContainer = styled(Flex)`
  justify-content: space-between;
  padding-left: 0.2em;
`

export const TrashIcon = styled(FontAwesomeIcon)`
   color: #d24444;
   &:hover {
      cursor: pointer;
      color: ${lighten(0.5, defaultIconColor)} };
    }
`

export const CardTitle = styled.p`
  font-weight: bold;
`

export const DateInfo = styled(Flex)`
  align-items: center;
  padding-left: 0.2em;
`

export const DateText = styled.p`
  margin: 0 0 0 1em;
`

export const BottomHalf = styled(Flex)`
  align-items: center;
`
export const PersonInfo = styled(Flex)``

export const ProfileAvatar = styled.img`
  width: 2em;
  height: 2em;
  border-radius: 50%;
  margin-right: 1em;
`
export const PersonName = styled.p`
  margin: 0;
  align-self: center;
`

export const RequestStatus = styled.p<{
  status: IAbsenceRequestStatus
}>`
  margin: 0;
  padding: 0.2em 1.2em;
  border-radius: 25px;
  background: ${({ status }) => statusColor(status)};
  color: white;
`

export const ModalContainer = styled(Flex)`
  padding: 20px;
`

export const ModalButtonContainer = styled(Flex)`
  margin-top: 25px;
`
